import { merge } from 'lodash';

import { post } from '../../01-helpers/services/ajax';
import { publish } from '../../01-helpers/event-manager';

import { ADDTOCART_FAILED, ADD_TO_CART } from '../../02-const/event-names';

/* ========================================================================== */

const defaultParams = {};

export default (data => new Promise((resolve, reject) => {
    post(
        '/umbraco/api/cart/addToCart',
        {
            // add data to api call
            data: JSON.stringify(merge({}, defaultParams, data)),
            contentType: 'application/json'
        }
    )
        .done(data => resolve(data)).fail(reject)
}));
